import { defineMessages } from 'react-intl';

export default defineMessages({
    qr2x2: {
        id: 'app.components.studentUnAssign.qr2x2',
        defaultMessage: 'QR codes 2x2'
    },
    qr3x3: {
        id: 'app.components.studentUnAssign.qr3x3',
        defaultMessage: 'QR codes 3x3'
    },
    f2x5: {
        id: 'app.components.studentUnAssign.f2x5',
        defaultMessage: '2x5 label'
    },
    f2x7: {
        id: 'app.components.studentUnAssign.f2x7',
        defaultMessage: '2x7 label'
    },
    f3x8: {
        id: 'app.components.studentUnAssign.f3x8',
        defaultMessage: '3x8 label'
    },
    downloading: {
        id: 'app.components.studentUnAssign.downloading',
        defaultMessage: 'downloading'
    },
    download: {
        id: 'app.components.studentUnAssign.download',
        defaultMessage: 'download'
    },
    header: {
        id: 'app.components.studentUnAssign.header',
        defaultMessage: 'Please select format for sign in cards'
    }
});



// WEBPACK FOOTER //
// ./app/components/sign-in-cards-formats/messages.js